// This file was automatically generated from securityQAReset.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.securityQAReset');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.multiuser_access.signup');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.securityQAReset.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><form id="main-form"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><h3 class="el8BrandColor el8LightWeight el8AlignCenter">Set up new security question and answer</h3><div class="el8LgSpacer"></div><h4 class="el8AlignCenter mbMd">Secure your account with a new security question and answer</h4><div class="el8LgSpacer"></div><div class="w80p el8FormHorizontal el8CenterBlock">');
  el8.template.multiuser_access.signup.securityQA(opt_data, output);
  output.append('<div class="el8SmSpacer"></div><div class="el8AlignCenter"><button id="go-to-chart" class="el8Btn el8BtnPrimary">Set new security answer and go to chart</button></div></div><div class="el8XLSpacer"></div></div></form></div>');
  if (!opt_sb) return output.toString();
};
